/**
 * THIS FILE IS AUTOGENERATED, DO NOT EDIT IT!
 *
 * instead, edit one of the `.graphql` files in this project and run
 * `pnpm nx run graphql:codegen `
 * for this file to be re-created
 */
import * as Types from '@main/graphql/types.admin.generated';

import type { TypedDocumentNode } from '@graphql-typed-document-node/core';
import * as ClientTypes from '@main/graphql/client-scalars';
import { api } from '@main/graphql/shared-api';
export type GetOrgCustomRolesQueryVariables = Types.Exact<{
  orgId: Types.Scalars['uuid']['input'];
}>;

export type GetOrgCustomRolesQuery = {
  __typename?: 'query_root';
  roles: Array<{
    __typename?: 'roles';
    id: string;
    name: string;
    system_role?: Types.System_Roles_Enum | null;
  }>;
};

export const GetOrgCustomRolesDocument = `
    query GetOrgCustomRoles($orgId: uuid!) {
  roles(where: {organization_id: {_eq: $orgId}}) {
    id
    name
    system_role
  }
}
    ` as string & TypedDocumentNode<GetOrgCustomRolesQuery, GetOrgCustomRolesQueryVariables>;

const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    GetOrgCustomRoles: build.query<GetOrgCustomRolesQuery, GetOrgCustomRolesQueryVariables>({
      query: (variables) => ({ document: GetOrgCustomRolesDocument, variables }),
    }),
  }),
});

export { injectedRtkApi as api };
export const { useGetOrgCustomRolesQuery, useLazyGetOrgCustomRolesQuery } = injectedRtkApi;
